export const MIN_DESKTOP_WIDTH = 1024;
export const PATIENT_WEB_LOCALE_STORAGE_KEY = "langCode";
export const ACCOUNTS_LOCALE_STORAGE_KEY = "App[ActiveLanguage]";
export const RANDOM_NONCE = "hY7p2Qw8XzMv3K9B";
